<template>
  <div>
    <v-row>
      <v-col>
        <v-card tile flat class="my-5">
          <v-card-text class="pa-0">
            <v-row no-gutters>
              <v-col cols="2">
                <div class="bg-kiri"></div>
              </v-col>
              <v-col cols="10" class="pa-5">
                <h1 class="headline">Modul Perangkat Pendampingan FSP</h1>
                <p>
                  Berikut adalah modul perangkat pendampingan FSP yang dapat Anda akses dan dijadikan panduan dalam
                  pelaksanaan kegiatan pendampingan.
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(perangkat, angkatan) in perangkats" :key="angkatan" cols="12" lg="6">
        <v-card outlined :href="perangkat" target="_blank">
          <v-list-item>
            <v-list-item-avatar size="80" color="indigo" rounded>
              <v-icon color="white" size="45">mdi-file-document-multiple</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div class="mb-2">
                <v-chip color="pink" class="white--text" small>Angkatan {{ angkatan }}</v-chip>
              </div>
              <div style="font-size: 20px">Modul Perangkat</div>
              <div class="body-1 font-weight-medium">Repositori Panduan PSP {{ angkatan }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6"></v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ModulPendampingan',
  computed: {
    ...mapState('preferensi', {
      perangkats: (state) => state.data?.perangkat ?? '',
    }),
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
